import StatCard from '../../components/common/StatCard';
import Button from '../../components/common/Button';
import './LazyMarketing.css';

const Video = () => {
  const stats = [
    { label: 'Total Videos', value: '89', change: '+12', changeType: 'positive' },
    { label: 'Views', value: '124K', change: '+23%', changeType: 'positive' },
    { label: 'Avg. Watch Time', value: '3:42', change: '+18s', changeType: 'positive' },
    { label: 'Engagement', value: '8.4%', change: '+1.2%', changeType: 'positive' },
  ];

  const videos = [
    { title: 'Product Demo 2024', views: '45K', duration: '5:32', status: 'Published' },
    { title: 'Customer Testimonial', views: '23K', duration: '2:15', status: 'Published' },
    { title: 'How-To Guide', views: '18K', duration: '8:45', status: 'Published' },
    { title: 'Brand Story', views: '0', duration: '4:20', status: 'Processing' },
  ];

  return (
    <div className="lm-page">
      <div className="lm-page-header">
        <h1 className="lm-page-title">Video & Avatar</h1>
        <p className="lm-page-subtitle">Create and manage video content</p>
      </div>

      <div className="lm-stats-row">
        {stats.map((stat, index) => (
          <StatCard key={index} {...stat} />
        ))}
      </div>

      <div className="lm-section">
        <div className="lm-section-header">
          <h3 className="lm-section-title">Video Library</h3>
          <Button variant="primary" size="sm" icon="plus">Create Video</Button>
        </div>
        <div className="lm-grid">
          {videos.map((video, index) => (
            <div key={index} className="lm-grid-card">
              <div className="lm-grid-card-header">
                <span className="lm-grid-card-title">{video.title}</span>
                <span className="lm-grid-card-badge" style={{
                  background: video.status === 'Published' ? 'var(--success-soft)' : 'var(--warning-soft)',
                  color: video.status === 'Published' ? 'var(--success)' : 'var(--warning)'
                }}>{video.status}</span>
              </div>
              <div className="lm-grid-card-content">
                <p>{video.views} views • {video.duration}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Video;
